import * as Paginator from "react-bootstrap-table2-paginator";

import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import ToolkitProvider, { CSVExport, Search, } from "react-bootstrap-table2-toolkit";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { faDownload, faPlus, faSearch, } from "@fortawesome/free-solid-svg-icons";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import { getFieldEntryByDate, getFieldIssueWorkOrderExcelDownload, getFieldVisitPdfDownload, getFieldWorkOrderDetailsLExcel, getWorkOrderFieldIssueList, } from "../../Service/AllWorkOrderFieldIssueAPI";

import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Pagination from "react-bootstrap-table2-paginator";
import fileSaver from "file-saver";
import moment from "moment";
import swal from "sweetalert";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

export default () => {
  const { SearchBar } = Search;
  const { ExportCSVButton } = CSVExport;
  const selectRow = {
    mode: "checkbox",
  };
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [entries, setEntries] = useState([]);
  const [show, setShow] = useState(false);
  const [isLoaded, setisLoaded] = useState(false);
  // --- pagination
  const [currentPage, setcurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [totaloffset, setTotaloffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  // Function call to hide and show
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getFieldIssue(); // Function call to get field issue list
    // eslint-disable-next-line
  }, []);

  const handlePageChange = async (page) => {
    setEntries([]);
    const selectedPage = page - 1;
    console.log("selectedPage", selectedPage);
    if (fromDate === "" && toDate === "") {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      await getWorkOrderFieldIssueList( selectedPage, "field visit", fkUserId, role, headers )
      .then((result) => {
        console.log("Get Pagination field visit Result", result);
        if (result?.data?.content?.length !== 0) {
          const data = result.data.content;
          const totalSize = result.data.pageable.offset;
          console.log("data", data);
          setEntries(data);
          setPageCount(result.data.totalPages);
          setTotaloffset(totalSize);
          entries.map((item, index) => (item.id = totalSize + index + 1));
        } else {
          swal("Sorry", "Data is not present", "warning");
        }
      })
      .catch((error) => console.error("Error", error));
    } else if (fromDate !== "" && toDate !== "") {
      await getFieldEntryByDate( selectedPage, moment(fromDate).format("yyyy-MM-DD"), moment(toDate).format("yyyy-MM-DD") )
      .then((result) => {
        console.log("Get Pagination Date wise field visit Result", result);
        if (result?.data?.content?.length !== 0) {
          const data = result.data.content;
          const totalSize = result.data.pageable.offset;
          entries.map((item, index) => (item.id = totalSize + index + 1));
          console.log("totalSize", totalSize);
          console.log("data", data);
          setEntries(data);
          setTotaloffset(totalSize);
          setTotalCount(result.data.totalElements);
        }  else {
          setEntries([]);
          setPageCount();
          setTotalCount();
        }
      })
      .catch((error) => {
        console.log("Get Field Issue Error", error);
      });
    } else {
      swal("Failed", "Please select date", "error");
    }
  };

  const getFieldIssueExcelDownload = async () => {
    if (fromDate !== "" && toDate !== "") {
      try {
        await getFieldIssueWorkOrderExcelDownload(moment(fromDate).format("yyyy-MM-DD"), moment(toDate).format("yyyy-MM-DD"))
      } catch(error) {
        console.log("getFieldIssueWorkOrderExcelDownload error :-", error);
      }
    }
    try {
      let result = await getFieldWorkOrderDetailsLExcel();
      console.log("getFieldWorkOrderDetailsLExcel FieldIssueList result :-", result);
      let blob = new Blob([result.data], {type: "application/vnd.openxmlformats-officedocumnet.spreadsheetml.sheet"});
      fileSaver.saveAs(blob, "FieldWorkOrderFieldVisitList.xlsx");
    } catch (error) {
      console.log("getFieldWorkOrderDetailsLExcel FieldIssueList error :-", error);
    };
  }

  // Function declaration of get field issue list
  const getFieldIssue = async () => {
    try {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      await getWorkOrderFieldIssueList( currentPage, "field visit", fkUserId, role, headers )
      .then((result) => {
        console.log("Work Order FieldIssue Result List", result.data);
        if (result?.data?.content?.length !== 0) {
          const data = result.data.content;
          
          setEntries(data);
          setPageCount(result.data.totalPages);
          setTotalCount(result.data.totalElements);
        }  else {
          setEntries([]);
          setPageCount();
          setTotalCount();
        }
      })
      .catch((error) => {
        console.log("Work Order FieldIssue Error", error);
      });
    } catch (error) {
      console.log(error);
      swal( "Failed", "Something went wrong please check your internet", "error" );
    }
  };

  // const getFieldListByFromDate = (e) => {
  //   setFromDate(e.target.value);
  //   console.log(fromDate);
  //   if(e.target.value > new Date().toISOString().split("T")[0]){
  //     swal("Sorry", "Please select today or day before today", "warning");
  //   }
  // };

  // // Function declaration for setting toDate on "todate" field change event
  // const getFieldListByToDate = async (e) => {
  //   setToDate(e.target.value);
  //   console.log(toDate);
  //   if(e.target.value > new Date().toISOString().split("T")[0]){
  //     swal("Sorry", "Please select today or day before today", "warning");
  //   }
  // };

  const handleFromDateChange = (date) => {
    setFromDate(date);
    // Clear the "To" date if it's before the selected "From" date
    if (toDate && date > toDate) {
      setToDate(null);
    }
  };

  const handleToDateChange = (date) => {
    if (date < fromDate) {
      swal('Invalid Date', 'The "To" date cannot be before the "From" date.', 'warning');
      setToDate(null); // Reset "To" date if invalid
    } else {
      setToDate(date);
    }
  };

  const getFieldListByDate = async () => {
    try {
      if (fromDate !== "" && toDate !== "") {
        await getFieldEntryByDate( currentPage, moment(fromDate).format("yyyy-MM-DD"), moment(toDate).format("yyyy-MM-DD") )
        .then((result) => {
          console.log("Get Field Visit Result", result.data);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            setEntries(data);
            setPageCount(result.data.totalPages);
            setTotalCount(result.data.totalElements);
          } else {
            setEntries([]);
            setPageCount();
            setTotalCount();
            swal("Sorry", "Data is not present", "warning");
          }
          // console.log("setNoOfElements", noOfElements);
        })
        .catch((error) => {
          console.log("Get Dealer Entry Error", error);
        });
      } else {
        swal("Failed", "Please select date", "error");
      }
    } catch (error) {
      console.log(error);
      swal( "Failed", "Something went wrong please check your internet", "error" );
    }
  };

  const getFieldReportPdfDownload = async () => {
    try {
      if (fromDate !== "" && toDate !== "") {
        setisLoaded(true);
        await getFieldVisitPdfDownload( moment(fromDate).format("yyyy-MM-DD"), moment(toDate).format("yyyy-MM-DD") );
        setisLoaded(false);
      } else {
        swal("Failed", "Please select date", "error");
      }
    } catch (error) {
      setisLoaded(false);
      console.log(error);
      swal( "Failed", "Something went wrong please check your internet", "error" );
    }
  };

  const userRole =sessionStorage.getItem('role')
  // Adding srno column to list
  entries.map((item, index) => (item.id = totaloffset + index + 1));

  // Column heading of Field Visit list
  const columns = [
    { dataField: "id", text: "Id" },
    {
      dataField: "status",
      text: "Field job WO Status",
      editable: false,
      style: {
        textTransform: "capitalize",
      },
    },
    
    {
      dataField: "workOrderSerialNo",
      text: "Field job WO Sr No",
      editable: false,
    },
   
    {
      dataField: "workOrderDate",
      text: "WO Created On",
      editable: false,
      formatter: (cell) => {
        return <>{moment(cell).format("DD-MMM-YYYY")}</>;
      }
    },

    {
      dataField: "workOrderTime",
      text: "Wo Created Time",
      editable: false,
      formatter: (cell) => {
        return <>{moment(cell, "hh:mm A").format("hh:mm A")}</>;
      },
    },
  
    // {
    //   dataField: "fieldVisitDate",
    //   text: "Wo closed On",
    //   editable: false,
    //   formatter: (cell) => {
    //     return <>{moment(cell).format("DD-MMM-YYYY")}</>;
    //   },
    // },
    // {
    //   dataField: "fieldVisitTime",
    //   text: "WO Closed Time",
    //   editable: false,
    //   formatter: (cell) => {
    //     return <>{moment(cell, "hh:mm A").format("hh:mm A")}</>;
    //   },
    // },

    {
      dataField: "generateUniqueDispenserNo",
      text: "Dispenser Sr No",
      editable: false,
    },
    {
      dataField: "description",
      text: "WO description",
      editable: false,
      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell}</div>
          {cell.length > 20 && (
            <span className="tooltip-text">{row.description}</span>
          )}
        </div>
      )
    },
    {
      dataField: "address",
      text: "Site Address",
      editable: false,
      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell}</div>
          {cell.length > 20 && (
            <span className="tooltip-text">{row.address}</span>
          )}
        </div>
      )
    },
    {
      dataField: "dispenserType",
      text: "Dispenser config",
      editable: false,
    },
    {
      dataField: "customerName",
      text: "Customer Name",
      editable: false,
    },
    
    // {
    //   dataField: "dealerName",
    //   text: "Dealer Name",
    //   editable: false,
    // },
    {
      dataField: "serviceEngineerName",
      text: "Service Engineer Name",
      editable: false,
    },
    {
      dataField: "serviceEngineerMobNo",
      text: "Service Engineer Mobile No",
      editable: false,
    },
    {
      dataField: "jobType",
      text: "Job Type",
      editable: false,
    },

    // {
    //   dataField: "jobPreference",
    //   text: "Communication type",
    //   editable: false,
    // },
    
   
    {
      dataField: "siteType",
      text: "Site Type",
      editable: false,
    },
   
    ...(userRole === 'admin' ? [{
      dataField: "whoDidIt",
      text: "Field job Wo Created by",
      editable: false,
      headerAlign: "left",
    }] : []),
    // {
    //   dataField: "timeTaken",
    //   text: "Time Taken",
    // },
    // {
    //   dataField: "action",
    //   text: "Action",
    //   editable: false,
    //   formatter: (cell) => {
    //     return (
    //       <button value={cell} onClick={handleShow} className="btn btn-primary">
    //         {cell} View More
    //       </button>
    //     );
    //   },
    // },
  ];

  // custom the pagination total
  const customTotal = (from, to, size) => (
    <div>
      Showing {totaloffset + from} to {totaloffset + to} of {size} entries
    </div>
  );

  // callback function when page was changing
  const customSizePerPage = (props) => {
    const { options, currentSizePerPage, onSizePerPageChange } = props;
    const onPageChange = (e) => {
      const page = e.target.value;
      onSizePerPageChange(page);
    };

    return (
      <>
        <Row>
          <Col xs="auto">
            <Form.Select
              value={currentSizePerPage}
              onChange={onPageChange}
              className="pe-5"
            >
              {options.map((o) => (
                <option key={o.page} value={o.page}>
                  {o.text}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col xs="auto" className="d-flex align-items-center">
            Entries per page
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      {isLoaded ? (
        <div className="reportload"></div>
      ) : (
        <Formik
          initialValues={{
            firstname: "",
            lastname: "",
            companyname: "",
            mobileno: "",
            selectdesignation: "",
            email: "",
            country: "",
            state: "",
            address: "",
            city: "",
            desc: "",
          }}
          onSubmit={async (values) => {
            console.log(JSON.stringify(values, null, 2));
          }}
        >
          {(formik) => {
            return (
              <>
                <Modal show={show} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title>Field Visit</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {/* pop-up */}
                    <Form>
                      <Row>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <Field
                              type="checkbox"
                              //className="form-control form-control-sm"
                              className="mx-5 mt-4"
                              name="customernow"
                            />
                            <label>OTP</label>
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            {/* <label>Date</label> */}
                            <Field
                              type="datetime-local"
                              className="form-control my-2"
                              name="machinetype"
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12} className="mb-3">
                          <div className="form-group">
                            <label>Upload Despencer Photo</label>
                            <Field
                              type="file"
                              className="form-control"
                              name="photo"
                              title="Add photo"
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12} className="mb-3">
                          <div className="form-group">
                            <label>Description</label>
                            <Field
                              className="form-control"
                              rows="4"
                              placeholder="Description"
                              title="Enter Description"
                              name="prod_desc"
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                      Submit
                    </Button>
                  </Modal.Footer>
                </Modal>
                {/* <div className="newadd" align="right">
                  <button className="btn btn-secondary">
                    <Link to="fieldissue">
                      <FontAwesomeIcon icon={faPlus} className="me-2" />
                      <span>Create Field Visit WO</span>{" "}
                    </Link>
                  </button>
                </div>
                <br /> */}
                <Row>
                  <Col md={3} className="mb-3">
                  <div className="form-group">
                <label>From Date</label>
                <DatePicker
                  selected={fromDate}
                  onChange={handleFromDateChange}
                  dateFormat="dd-MMM-yyyy"
                  maxDate={new Date()}
                  className="form-control"
                  placeholderText="DD-MMM-YYYY"
                  showYearDropdown
                  scrollableYearDropdown
                />
              </div>
                  </Col>
                  <Col md={3} className="mb-3">
                  <div className="form-group">
                <label>To Date</label>
                <DatePicker
                  selected={toDate}
                  onChange={handleToDateChange}
                  dateFormat="dd-MMM-yyyy"
                  minDate={fromDate}
                  maxDate={new Date()}
                  className="form-control"
                  placeholderText="DD-MMM-YYYY"
                  showYearDropdown
                  scrollableYearDropdown
                />
              </div>
                  </Col>
                  <Col md={3} className="mb-3">
                    <button
                      className="btn btn-secondary mt-lg-4"
                      onClick={getFieldListByDate}
                    >
                      <FontAwesomeIcon icon={faSearch} className="me-2" />
                      <span>Search By Date</span>{" "}
                    </button>
                  </Col>
                </Row>
                {/* When you use any toolkit functionalities, you are supposed to render toolkit
                component and BootstrapTable as the children of ToolkitProvider */}
                <ToolkitProvider
                  keyField="id"
                  search={true}
                  columns={columns}
                  data={entries}
                  exportCSV={{ onlyExportFiltered: true, exportAll: false }}
                >
                  {({ baseProps, searchProps, csvProps }) => (
                    //render the Pagination component as a list with left and right arrows
                    <Paginator.PaginationProvider
                      pagination={Pagination({
                        custom: true,
                        disablePageTitle: true,
                        alwaysShowAllBtns: true,
                        totalSize: totalCount,
                        paginationTotalRenderer: customTotal,
                        onPageChange: handlePageChange,
                      })}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <Card>
                          <div className="table-responsive py-2">
                            <Card.Header>
                              <Row>
                                <Col xs={12} md={6} className="py-1">
                                  {/* <Paginator.SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  /> */}
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  className="d-flex justify-content-md-end py-1"
                                >
                                  {/* props for search component */}
                                  {/* <Search.SearchBar {...searchProps} />{" "} */}
                                  {/* props for csv component */}
                                  {/* <ExportCSVButton
                                    {...csvProps}
                                    className="btn btn-secondary mx-2"
                                  >
                                    <span>CSV</span>{" "}
                                  </ExportCSVButton>  */}
                                  <button
                                    className="btn btn-secondary"
                                    onClick={getFieldReportPdfDownload}
                                  >
                                    <FontAwesomeIcon icon={faDownload} className="me-2" />
                                    <span>PDF</span>{" "}
                                  </button>
                                  <button className="btn btn-secondary mx-2" onClick={getFieldIssueExcelDownload}>
                                    <FontAwesomeIcon icon={faDownload} className="me-2" />
                                    <span>Excel</span>
                                  </button>
                                </Col>
                              </Row>
                            </Card.Header>
                            <BootstrapTable
                              {...baseProps}
                              {...paginationTableProps}
                              bodyClasses="border-0"
                              rowClasses="border-bottom"
                              classes="table-flush dataTable-table"
                                headerClasses="header-class"
                              wrapperClasses="table-responsive"
                              filter={filterFactory()}
                              hover
                              condensed
                              remote={{ pagination: true }}
                              cellEdit={cellEditFactory({
                                mode: "click",
                                blurToSave: true,
                                afterSaveCell: (
                                  oldValue,
                                  newValue,
                                  row,
                                  column
                                ) => {
                                  console.log(oldValue, newValue, row, column);
                                },
                              })}
                              //selectRow={selectRow}
                            />
                            <Card.Footer>
                              <Row>
                                <Col
                                  xs={12}
                                  md={6}
                                  className="d-flex align-items-center py-1"
                                >
                                  {/* <Paginator.PaginationTotalStandalone
                            {...paginationProps}
                          /> */}
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                                >
                                  <Paginator.PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </Card.Footer>
                          </div>
                        </Card>
                      )}
                    </Paginator.PaginationProvider>
                  )}
                </ToolkitProvider>
              </>
            );
          }}
        </Formik>
      )}
    </>
  );
};
